namespace GeniuzPOS.Purchase {
    export class PoPurInvoiceColumns {
        static columnsKey = 'Purchase.PoPurInvoice';
    }
}
